export const isInIframe = () => {
  try {
    return window.self !== window.top;
    // return true;
  } catch (e) {
    return true;
  }
};
